import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ManufacturingPage from "../pages/manufacturing/page";
import ProductsPage from "../pages/products/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/manufacturing-and-distribution",
    element: <ManufacturingPage />,
  },
  {
    path: "/products-and-services",
    element: <ProductsPage />,
  },
  {
    path: "/contact-us",
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
